<ng-container *transloco="let t; read: 'user'">
  <div class="fix-action-row modal-body">
    <div class="flex justify-between border-b">
      <h1 class="text-[25px] font-bold">
        {{ t('manageEnrollment.confirmSpedExitDate.title') }}
      </h1>
      <i mat-button mat-dialog-close class="text-drdpblue-300 cursor-pointer uil uil-times-circle"></i>
    </div>

    <div mat-dialog-content>
      @if (batchResults.isSuccess) {
        <div class="mt-4"> {{ t('manageEnrollment.confirmSpedExitDate.updatedChildren') }}</div>
      }
      <div class="mt-2">
        <ul>
          @for (student of batchResults.successfulStudents; track student) {
            <li>
              <!-- Child name is server-supplied. -->
              - <strong>{{ student }}</strong>
            </li>
          }
        </ul>
      </div>
      @if (batchResults.missingScoresStudents?.length > 0) {
        <div class="mt-4"> {{ t('manageEnrollment.confirmSpedExitDate.missingScores') }}</div>
      }
      <div class="mt-2">
        <ul>
          @for (student of batchResults.missingScoresStudents; track student) {
            <li>
              <!-- Child name is server-supplied. -->
              - <strong>{{ student }}</strong>
            </li>
          }
        </ul>
      </div>
      @if (batchResults.incompleteCOSStudents?.length > 0) {
        <div class="mt-4"> {{ t('manageEnrollment.confirmSpedExitDate.incompleteOutcomes') }}</div>
      }
      <div class="mt-2">
        <ul>
          @for (student of batchResults.incompleteCOSStudents; track student) {
            <li>
              <!-- Child name is server-supplied. -->
              - <strong>{{ student }}</strong>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <div mat-dialog-actions class="flex justify-end">
    <drdp-btn class="ml-3" mat-button cdkFocusInitial mat-dialog-close>{{ t('manageEnrollment.myClasses.actions.ok') }}</drdp-btn>
  </div>
</ng-container>
